import * as messages from "../../messages";
import { ScheduledVisitEditParams, VisitInstanceDetails } from "../../messages";
import { genericUpdate } from "../../utils/generic_update";
import { KeyedList } from "../../utils/List";

export interface AppScheduledVisitsState {
  readonly scheduledVisitDetails: KeyedList<messages.VisitInstanceDetails, "id">;
  readonly importedVisitDetails: KeyedList<messages.CaregiverImportedVisitDetails, "id">;
}

export class AppScheduledVisitsState {
  static fromMessage = (message: messages.CaregiverAssignedVisits): AppScheduledVisitsState => {
    return {
      scheduledVisitDetails: KeyedList.from<messages.VisitInstanceDetails>(message.visitInstances)(
        "id"
      ),
      importedVisitDetails: KeyedList.from<messages.CaregiverImportedVisitDetails>(
        message.importedVisits
      )("id"),
    };
  };

  static updateFromMessage = (
    appVisitEditRequestsState: AppScheduledVisitsState,
    message: messages.CaregiverAssignedVisits
  ): AppScheduledVisitsState => {
    return genericUpdate(appVisitEditRequestsState, AppScheduledVisitsState.fromMessage(message));
  };
}

export interface ScheduledVisitDetailsAndRequests {
  scheduledVisitDetails: VisitInstanceDetails;
  editRequestParams: ScheduledVisitEditParams | null;
}

export interface ScheduledVisitDetailsAndRequestsTaskUnion
  extends ScheduledVisitDetailsAndRequests {
  union_type: "SCHEDULED_VISIT";
}
